import { useState } from "react";

export function useReceipt() {
  const [receiptData, setReceiptData] = useState({
    monto: 0,
    cuenta_bancaria: 0,
    metodo_pago: "TRANSFERENCIA",
    documento: "",
    fecha_pago: new Date().toISOString().split("T")[0],
  });
  const [count, setCount] = useState(0);
  const [selectedFilial, setSelectedFilial] = useState(0);
  const [errors, setErrors] = useState({});

  function updateField(field, value) {
    setReceiptData((p) => ({ ...p, [field]: value }));
    // Limpiar el error del campo al editarlo
    if (errors[field]) {
      setErrors((prev) => {
        const e = { ...prev };
        delete e[field];
        return e;
      });
    }
  }

  function clearFilialError() {
    if (errors.filial) {
      setErrors((prev) => {
        const e = { ...prev };
        delete e.filial;
        return e;
      });
    }
  }

  /**
   * Valida los campos del recibo ANTES de verificar el restante.
   * Devuelve true si todo está bien, false si hay errores.
   * La lógica de restante=0 la sigue manejando ReceiptFooter con showRestanteError.
   */
  /**
   * @param {function} [montoEsValidoFn] - si se pasa, sobreescribe la
   * validación de monto. Viene de useCxc.montoEsValido y permite monto=0
   * cuando hay CxC negativas (saldo a favor) seleccionadas.
   */
  function validate(montoEsValidoFn, soloSaldoFavor = false) {
    const e = {};

    if (!selectedFilial || selectedFilial === 0) {
      e.filial = "Seleccioná una filial.";
    }

    // Si se pasa montoEsValidoFn, delegar la validación de monto en useCxc
    const montoValido = montoEsValidoFn
      ? montoEsValidoFn()
      : !!receiptData.monto && Number(receiptData.monto) > 0;
    if (!montoValido) {
      e.monto =
        "El monto debe ser mayor a 0. (Puede ser 0 si aplicás saldo a favor)";
    }

    if (!receiptData.fecha_pago) {
      e.fecha_pago = "La fecha de pago es obligatoria.";
    }

    if (!soloSaldoFavor && (!receiptData.cuenta_bancaria || receiptData.cuenta_bancaria === 0)) {
      e.cuenta_bancaria = "Seleccioná una cuenta bancaria.";
    }

    // Cuando es solo saldo a favor, el documento se genera automáticamente
    if (!soloSaldoFavor && (!receiptData.documento || receiptData.documento.trim() === "")) {
      e.documento = "La referencia bancaria es obligatoria.";
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  }

  function clearErrors() {
    setErrors({});
  }

  return {
    receiptData,
    setReceiptData,
    updateField,
    count,
    setCount,
    selectedFilial,
    setSelectedFilial,
    errors,
    validate,
    clearErrors,
    clearFilialError,
  };
}
